"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountGuarantor = void 0;
/**
 * A financial tool for tracking value accrued for a particular purpose.  In the healthcare field, used to track charges for a patient, cost centers, etc.
 */
var AccountGuarantor = /** @class */ (function () {
    function AccountGuarantor() {
    }
    return AccountGuarantor;
}());
exports.AccountGuarantor = AccountGuarantor;
